// ADSManager.js
var ADSManager = pc.createScript('adsManager');

const ADS_ID_Array = ['107b707a-2caa-4b9e-ac06-24d756c37c05'];
const ADS_ID = '107b707a-2caa-4b9e-ac06-24d756c37c05';

ADSManager.prototype.initialize = function () {

    ADSManager.instance = this;
    this.log = new Log("ADS_MANAGER");

    this.matchStartAds = false;
};

ADSManager.prototype.initialADS = async function() {

    await sc.initializeAds(ADS_ID_Array)
        .then((response) => {
            ADSManager.instance.log.info("ADS Initialized");
        })
        .catch((error) => {
            ADSManager.instance.log.info("ADS Initialize Error:");
            ADSManager.instance.log.info(error);
        });
};

ADSManager.prototype.OpenRewardVideo = async function(adsShowType, _gameFinishStatus){
    
    this.adsShowTypeValue = adsShowType;
    
    // if (sc.app) {

    //     await sc.watchAd(ADS_ID)
    //         .then((response) => {
    //             ADSManager.instance.log.info("Reklamda hata yok");

    //         })
    //         .catch((error) => {
    //             ADSManager.instance.log.info("Reklamda Hata:");
    //             ADSManager.instance.log.info(error);
    //             this.completeAds();
    //         });

    // } else {
    //     ADSManager.instance.log.info("Web Kullanımından Dolayı Reklam Gösterilemedi");
    //     this.completeAds();
    // }
    this.completeAds(_gameFinishStatus);
};

ADSManager.prototype.continueSound = function () {
    
    var timeoutHandle;
    var soundSystem = this.app.systems.sound;

    if (timeoutHandle) {
        clearTimeout(timeoutHandle);
    }

    soundSystem.context.suspend();

    timeoutHandle = setTimeout(function () {
        if (soundSystem.context.state !== 'running') {
            soundSystem.context.resume();
        }
    }, 100);
};

ADSManager.prototype.completeAds = function (finishType) {

    ADSManager.instance.continueSound();

    if (this.adsShowTypeValue === adsEnum.Interstitial) {
        
        if (this.matchStartAds == true) {
             GameManager.instance.ExtraTime();
             this.matchStartAds=false;
        }
        else if (playExtraTime == true) {
            GameManager.instance.GameStart();
        }
        else {
            if (finishType == adsGameFinishEnum.Lose) {
                GameManager.instance.GameLose();
            }
            else if (finishType == adsGameFinishEnum.CompleteMatch) {
                completeMatchStatus = true;
                GameManager.instance.GameWin();
            }
            else if (finishType == adsGameFinishEnum.Win) {
                
                GameManager.instance.GameWin();
            }
        }
    }
    else if(this.adsShowTypeValue === adsEnum.MatchThemAll) {
         GameManager.instance.OfferPlay(false);
    }
    else if(this.adsShowTypeValue === adsEnum.ShakeBoard) {
        ShakeTable.instance.shakeAnimation();
    }
    else if(this.adsShowTypeValue === adsEnum.JokerMiniWordGame) {
         WordMiniGameJoker.instance.jokerAction();
    }
    else if(this.adsShowTypeValue === adsEnum.JokerMiniLinkGame) {
         WordMiniGameJoker.instance.jokerLinkGame();
    }
    else if(this.adsShowTypeValue === adsEnum.JokerMiniMathGame) {
         WordMiniGameJoker.instance.jokerMathGame();
    }
    else if(this.adsShowTypeValue === adsEnum.JokerMiniAttentionGame) {
         WordMiniGameJoker.instance.jokerAttentionGame();
    }
    else {
        GameManager.instance.OfferPlay(true);
    }
};

ADSManager.prototype.checkADSReady = async function (callback) {
    
    if (sc.app) {
        var isAdReady = await sc.isAdReady(ADS_ID);

        if (isAdReady.isReady) {

            ADSManager.instance.log.info("Reklam Hazır");
            callback(true);
        } else {

            callback(false);
            ADSManager.instance.log.info("An Ad is not ready at this time. Please try again later.");
        }
    }
    else if (sc.pc){
        callback(true);
    }
};

ADSManager.prototype.onAdReady = function(response){
    
    if (response === ADS_ID) {
        ADSManager.instance.log.info("Adready Hazır:");
    }  
};




